export const SET_CUSTOMERS_IMPORT_COUNT = 'SET_CUSTOMERS_IMPORT_COUNT'
export const SET_CUSTOMERS_IMPORT_IS_ERROR = 'SET_CUSTOMERS_IMPORT_IS_ERROR'
